export const en = {
    news: 'News'
};
